module.exports = __webpack_public_path__ + "img/yurt-ara.090f18e2.svg";